/*
 * @Author: Pension 744056574@qq.com
 * @Date: 2022-08-10 10:48:35
 * @LastEditors: Andy
 * @LastEditTime: 2024-05-10 16:10:27
 * @FilePath: /njyx-frontend-pc/packages/share/utils/dictionary.ts
 * @Description:数字字典文件
 *
 */
// 基础状态
export const baseStatusList: Record<string, any> = {
  "-1": "全部",
  1: "启用",
  0: "禁用",
};
//评价状态
export const evaluationType: Record<string, any> = {
  "-1": "全部",
  1: "显示中",
  0: "已隐藏",
};

// 贸易类型
export const tradeTypeList: Record<string, any> = {
  "-1": "全部",
  1: "一般贸易",
  2: "保税贸易",
  3: "快件直邮",
};
// 导出类型
export const exportTypeList: Record<string, any> = {
  "-1": "全部",
  1: "测试导出",
  2: "",
  3: "",
};
// 导出状态
export const exportStatusList: Record<string, any> = {
  0: "生成中",
  1: "已经生成",
  2: "未生成",
  3: "失败",
};
// 商品等级
export const goodsGrade: Record<string, any> = {
  0: "无",
  1: "S级",
  2: "A级",
  3: "B级",
  4: "C级",
  5: "D级",
  6: "E级",
  7: "F级",
  8: "G级",
  9: "H级",
  10: "I级",
  11: "J级",
  12: "K级",
  13: "L级",
  14: "M级",
  15: "N级",
  16: "O级",
  17: "P级",
  18: "Q级",
  19: "R级",
  20: "T级",
  21: "U级",
  22: "V级",
  23: "W级",
  24: "X级",
  25: "Y级",
  26: "Z级",
};

// 优惠券会员类型
export const memberType: Record<string, any> = {
  1: "全部会员",
  2: "指定会员",
  3: "新注册会员",
  4: "商品新客"
};
// 会员类型
// export const sourceMemberType: Record<string, any> = {
//   1: "全部会员",
//   2: "指定会员",
//   3: "新注册会员",
//   4: "商品新客"
// };

export const memberType1: Record<string, any> = {
  1: "全部会员",
  2: "指定会员",
};
// 门店类型
export const shopType: Record<string, any> = {
  1: "全部门店",
  2: "指定门店参与",
  3: "指定门店不参与",
};
export const shopType1: Record<string, any> = {
  1: "全部门店",
  2: "指定门店",
};
export const displayPosition: Record<string, any> = {
  1: "商详页",
  2: "提单页",
};
// 优惠券发放方式
export const couponSendType: Record<string, any> = {
  1: "注册发放",
  2: "人工注券",
};
// 优惠券状态,  待审核、审核不通过、待开始、发放中、已结束、已作废
export const couponStatus: Record<string, any> = {
  "-2": "全部",
  //   "-1": "强制结束",
  0: "已作废",
  1: "发放中",
  2: "待审核",
  3: "待开始",
  4: "已结束",
  5: "审核不通过",
};
//特价，组合活动状态
export const commbineStatus: Record<string, any> = {
  "-2": "全部",
  //   "-1": "强制结束",
  0: "已作废",
  1: "进行中",
  // 2: "待审核",
  3: "待开始",
  4: "已结束",
  // 5: "审核不通过",
};

// 优惠券类型
export const couponType: Record<string, any> = {
  1: "商品立减券",
  2: "商品折扣券",
};
// 优惠券使用类型
export const couponUseType: Record<string, any> = {
  1: "开始结束时间",
  2: "领取多少天后失效",
};
// 广告链接类型
export const adLinkType: Record<string, any> = {
  1: "URL",
  2: "商品",
  3: "素材",
  4: "消息",
};
// 展示角色
export const showRole: Record<string, any> = {
  "-1": "所有角色",
  1: "老板",
  2: "员工",
};
// 员工状态
export const staffStatus: Record<string, any> = {
  "-1": "全部",
  1: "在职",
  0: "离职",
};
// 销售状态
export const sellStatus: Record<string, any> = {
  "-1": "全部",
  1: "允许",
  0: "禁止",
};
// 门店状态
export const shopStatus: Record<string, any> = {
  "-1": "全部",
  0: "禁用",
  1: "开启",
  2: "待审核",
  3: "审核驳回",
  // 4: "待开通",
  5: "开通失败",
};

// 退单方式状态
export const returnStatus: Record<string, any> = {
  "-1": "全部",
  0: "仅退款",
  1: "退货退款",
};
// 推送方式状态
export const pushType: Record<string, any> = {
  0: "全部",
  2: "定时推送",
  1: "立即推送",
};
// 消息状态
export const pushStatus: Record<string, any> = {
  "-1": "全部",
  2: "待推送",
  0: "已取消",
  1: "推送成功",
  3: "推送失败",
};

//提现状态
export const withdrawaStatus: Record<string, any> = {
  "-1": "全部",
  0: "待审核",
  1: "审核拒绝",
  2: "打款中",
  3: "打款成功",
  4: "打款失败",
};
export const withdrawaStatus1: Record<string, any> = {
  0: "待审核",
  2: "审核拒绝",
  1: "打款中",
  3: "打款成功",
  4: "打款失败",
};
export const withdrawaStatu2: Record<string, any> = {
  0: "待审核",
  1: "审核成功",
  2: "审核拒绝",
  4: "打款成功",
  5: "打款失败",
  6: "已作废",
};
//账号类型
export const accountType: Record<string, any> = {
  "-1": "全部",
  0: "连锁",
  1: "门店",
  2: "员工",
};

//账户类型
export const accountsType: Record<string, any> = {
  "-1": "全部",
  0: "对公账户",
  1: "对私账户",
};

//账户类型1
export const accountsType1: Record<string, any> = {
  //  0: "全部",
  1: "对公",
  2: "对私",
};
//活动限制类型
export const actLimitTypes: Record<string, any> = {
  1: "不限制",
  2: "按单限制",
  3: "按听限制",
};

//税金类型
export const taxesTypes: Record<string, any> = {
  2: "活动价",
  1: "原价",
  0: "包税",
};

//活动状态
// export const activityStatus: Record<string, any> = {
//   1: "审核通过",
//   2: "审核拒绝",
//  0: "待审核",
// };
//活动状态
export const activityStatus: Record<string, any> = {
  "-2": "全部",
  //   "-1": "强制结束",
  0: "已作废",
  1: "进行中",
  // 2: "待审核",
  3: "待开始",
  4: "已结束",
  // 5: "审核不通过",
};

//账号类型
export const linkType: Record<string, any> = {
  "003": "门店",
  "004": "店员",
  "005": "连锁",
};

//退单方式
export const reType: Record<string, any> = {
  "-1": "全部",
  1: "仅退款",
  2: "退货退款",
};
//退单状态
export const reStatu: Record<string, any> = {
  WAIT_AUDIT: "待审核",
  WAIT_REFUND: "待退款",
  REFUND_ING: "退款中",
  FINISH: "已完成",
  CLOSE: "已关闭",
};

//导出类型
export const importType: Record<string, any> = {
  // 0: "无",
  1: "会员订单",
  2: "员工信息",
  3: "会员信息",
  4: "门店信息",
  5: "商品库存",
  6: "商品配额",
  7: "优惠券发放",
  8: "商品评价",
  9: "提现订单",
  10: "售后订单",
  11: "对账单",
  12: "广告报表",
  13: "协议同意",
  14: '销售列表',
  15: '提报列表'
};

//是否使用、是否推送成功
export const useType: Record<string, any> = {
  //  0: "全部",
  1: "是",
  0: "否",
};
//是否过期
export const outType: Record<string, any> = {
  //  0: "全部",
  1: "过期",
  0: "未过期",
};
// 是否公告
export const isNoticeType: Record<string, any> = {
  //  0: "全部",
  1: "是",
  0: "否",
};

// 配额门店
export const quotaShopType: Record<string, any> = {
  1: "全部门店",
  2: "指定门店",
  3: "指定省份",
  4: "指定区域经理",
};

//对账单状态
export const billStatus: Record<string, any> = {
  CREATE: "待确认",
  WAIT_FINISH: "待完成",
  FINISH: "已完成",
  CANCEL: "已作废",
};

//对账单类型
export const bankType: Record<string, any> = {
  //  0: "全部",
  1: "对公",
  2: "对私",
};

//直播状态
export const liveStatus: Record<string, any> = {
  "-2": "全部",
  "-1": "已作废",
  2: "进行中",
  0: "待审核",
  1: "未开始",
  3: "已结束",
};
//直播客户端
export const LiveClient: Record<string, any> = {
  //  0: "全部",
  1: "用户小程序",
  2: "门店App",
};
//直播商品状态
export const liveGoodsStatus: Record<string, any> = {
  2: "审核通过",
  0: "未审核",
  1: "审核中",
  3: "审核失败",
};
//商品货源
export const goodsSource: Record<string, any> = {
  1: "三方平台",
  2: "渝欧平台",
};


//下单规则状态
export const orderRulesStatus: Record<string, any> = {
  "-1": "全部",
  1: "启用",
  0: "禁用",
};

//下单规则状态
export const shipStatus: Record<string, any> = {
  1: "超时未发货",
  2: "超时已发货",
  3: "正常发货"
};
export const salesList: Record<string, any> = {
  1: "全部销售",
  2: "指定销售",
};

export const salesType: Record<string, any> = {
  'SALE': "销售代表",
  'DISTRICT_MANAGER': "地区经理",
  'AREA_MANAGER': '大区经理',
  'DATA_MANAGER': '纽迪希亚营养(香港)有限公司数据管理员'
};
export const salesTypeList: Record<string, any> = {
  '-1': "全部",
  'SALE': "销售代表",
  'DISTRICT_MANAGER': "地区经理",
  'AREA_MANAGER': '大区经理',
  'DATA_MANAGER': '纽迪希亚营养(香港)有限公司数据管理员'
};

export const districtList: Record<string, any> = {
  '华北': "华北",
  '华中': "华中",
  '华南': '华南'
};
export const areaTypeList: Record<string, any> = {
  '东北组': "东北组",
  '北一区': "北一区",
  '北二区': '北二区',
  '湖北组': "湖北组",
  '中一区': "中一区",
  '中二区': '中二区',
  '福建组': "福建组",
  '南一区': "南一区",
  '南二区': '南二区',
};
export const productGroupTypeList: Record<string, any> = {
  'CMA': "CMA",
  'FG': "FG",
  'KETO': 'KETO',
};

export const salesStatusList: Record<string, any> = {
  0: "禁用",
  1: "开启",
};

//提报状态
export const registerAuditStatus: Record<string, any> = {
  'FIRST_AUDIT_WAIT': "待审核",
  'SECOND_AUDIT_WAIT': "待复审",
  'FIRST_AUDIT_REJECT': '审核驳回',
  'SECOND_AUDIT_REJECT': '复审驳回',
  'SECOND_AUDIT_PASS': '待传输',
  'REFUSE_ACTIVE': '激活驳回',
  'TRANS_AUDIT_PASS': '提报通过',
  'TRANS_AUDIT_REJECT': '传输驳回',
};

export const reportingStatusList: Record<string, any> = {
  '-1': '全部',
  'FIRST_AUDIT_WAIT': "待审核",
  'SECOND_AUDIT_WAIT': "待复审",
  'FIRST_AUDIT_REJECT': '审核驳回',
  'SECOND_AUDIT_REJECT': '复审驳回',
  'SECOND_AUDIT_PASS': '待传输',
  'REFUSE_ACTIVE': '激活驳回',
  'TRANS_AUDIT_PASS': '提报通过',
  'TRANS_AUDIT_REJECT': '传输驳回',
}

export const modifiedStatus: Record<string, any> = {
  '-1': '全部',
  '1': '待审核',
  '2': '审核驳回',
  '3': '已更新'
}
export const modifiedStatusList: Record<string, any> = {
  '1': '待审核',
  '2': '审核驳回',
  '3': '已更新'
}
//文章评价状态
export const evaluationCommentType: Record<string, any> = {
  1: "显示",
  0: "隐藏",
};

export const bankCardAuthStatus: Record<string, any> = {
  'PENDING': "待审核",
  'REJECTED': '审核驳回',
  'APPROVED': '审核通过',
}


